// extracted by mini-css-extract-plugin
export default {"wrap":"On-z","logoContainer":"Pn-z","brandImg":"Qn-z","logoImg":"Rn-z","logoButton":"Sn-z"};